<template>
  <div class="pb-8 md:pb-20">
    <h1 class="text-4xl uppercase text-center pb-1.5 md:pb-3.5 md:pt-6">sire standings</h1>
    <hr/>
    <div class="py-7 mt-8" v-if="ready">
      <div v-if="!isLoggedIn" class="text-center w-full pt-10 pb-6">
        <!--        <svg class="w-10 inline-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">-->
        <!--          <path-->
        <!--              d="M80 192V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H80zM144 192H304V144C304 99.82 268.2 64 224 64C179.8 64 144 99.82 144 144V192z"/>-->
        <!--        </svg>-->
        <template v-if="arabian">
          <h2 class="text-[28px] md:text-[41px] max-w-[570px] mx-auto font-normal font-title uppercase">This area is restricted to members</h2>
        </template>
        <template v-else>
          <h2 class="text-[28px] md:text-[41px] max-w-[570px] mx-auto font-normal font-title uppercase">This area is restricted to subscribers</h2>
          <p class="font-normal text-2xl mb-8">You need to have an active print or digital subscription</p>
        </template>


        <div class="flex flex-col justify-center sm:flex-row bg-blackLight max-w-[820px] mx-auto mb-4 sm:mb-10 min-h-[330px]">

          <div class="w-full sm:basis-1/2 relative">
            <div class="absolute  top-[-100px] left-[-2%] sm:top-[-20px] sm:left-[-20px] z-[1] opacity-20 sm:opacity-100">
              <nuxt-img
                  format="webp"
                  preload
                  src="/subscribe/member-img-horse.png" alt="member subscribe" width="401" height="363"/>
            </div>
          </div>
          <div class="w-full sm:basis-1/2 flex flex-col justify-center z-[2]">
            <template v-if="arabian">
              <NuxtLink to="/login" class="min-w-[250px] mx-auto uppercase text-lg font-bold bg-white text-black p-3 hover:bg-veryDarkGray hover:text-white border-2 hover:border-white ">register</NuxtLink>
            </template>
            <template v-else>
              <NuxtLink to="/subscribe" class="min-w-[250px] mx-auto uppercase text-lg font-bold bg-white text-black p-3 hover:bg-veryDarkGray hover:text-white border-2 hover:border-white ">subscribe</NuxtLink>
            </template>
            <div v-if="!userName" class="min-w-[250px] mx-auto">
              <p class="py-2 text-grayLight text-tiny">OR</p>
              <p class="text-white mb-2">Are You a Member?</p>
            </div>
            <NuxtLink v-if="!userName" to="/login" class="min-w-[250px] mx-auto uppercase text-lg font-bold p-3 border-2 border-white hover:bg-darkRed text-white">login</NuxtLink>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="flex flex-wrap mb-3">
          <div class="w-full flex flex-wrap justify-center">
            <div class="flex items-center w-3/5 sm:w-2/5 lg:w-1/5 ">
              <label class="w-1/4 block font-bold text-tiny">Year :</label>
              <div class="relative w-1/2 border-none max-h-9">
                <select v-model="year"
                        class="text-black-400 border border-black-500  inline-block py-2 pl-3 pr-8 rounded leading-tight w-full"
                        @change="getData()">
                  <option v-for="item in years" :value="item">{{ item }}</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                  <i class="fas fa-chevron-down text-gray-400"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-8 p-2 w-full flex flex-wrap bg-grey-light">
          <div class="w-full lg:w-3/4">
            <div class="border border-gray-300 border-x-0 border-t-0">
              <button v-for="breed in breeds" @click="getData(breed.id)"
                      :class="(selectedBreed === breed.id)? '-mb-px py-2.5 px-3.5 border border-b-white rounded-b-none focus:border-b-white focus:border-gray-300 rounded hover:bg-gray-100 hover:opacity-70':'-mb-px py-2.5 px-3.5 border rounded-b-none border-white border-b-gray-300 focus:border-b-white focus:border-gray-300 rounded hover:bg-gray-100 hover:opacity-70'">
                {{ breed.name }}
              </button>
            </div>
            <div>
              <div v-if="readyTable">
                <table class="w-full">
                  <thead class="border border-1 border-b-4">
                  <tr class="">
                    <td class="p-1 md:p-3">Position</td>
                    <td class="p-1 md:p-3">Name</td>
                    <td class="p-1 md:p-3">Owner</td>
                    <td class="p-1 md:p-3">Points</td>
                  </tr>
                  </thead>
                  <tbody class="table-content-2 markup_content border border-1 border-b-4">
                  <tr class="border border-1 align-top" v-for="(item,key) in items">
                    <td class="p-1 md:p-3 text-center">
                      <span class="font-bold">{{ key+1 }}</span>
                    </td>
                    <td class="p-1 md:p-3">
                      <NuxtLink :to="'/horse/'+item.permalink"
                                class="text-darkRed hover:opacity-70 hover:text-darkBlue"><span>{{ item.name }}</span>
                      </NuxtLink>
                    </td>
                    <td class="p-1 md:p-3">
                      <NuxtLink v-if="item.owner_permalink" :to="'/owner/'+item.owner_permalink"
                                class="text-darkRed hover:opacity-70 hover:text-darkBlue"><span>{{ item.owner_name }}</span>
                      </NuxtLink>
                    </td>
                    <td class="p-1 md:p-3">
                      <span>{{ item.points }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-else>
                <LoadersSpinner/>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-1/4 p-4 text-center">
            <template v-if="page.images">
              <nuxt-img
                  preload
                  format="webp"
                  width="360"
                  :src="
                  siteURL+
                    '/storage/images/results/' +
                      page.path +
                      '/' +
                      page.images"
                  :alt="page.name"
              />
            </template>
            <div class="ql-snow">
              <div class="ql-editor">
                <div class="mb-4" v-html="page.content"></div>
              </div>
            </div>
            <h2  v-if="page_downloads.length > 0 && page_downloads.filter(item=> item.select_option === 2).length > 1" class="mt-7 text-lg font-body-font">ASB PERFORMANCE</h2>
            <template v-for="item in page_downloads">
              <template v-if="item.select_option === 1">
                <div class="flex flex-col">
                  <a :href="pdfURL + item.download" class="text-darkRed hover:text-darkBlue underline underline-offset-1"
                     href=""><span>{{ item.download_name }}</span></a>
                </div>
              </template>
            </template>
            <h2 v-if="page_downloads.length > 0 && page_downloads.filter(item=> item.select_option === 2).length > 0" class="mt-7 text-lg">ASB FUTURITY</h2>
            <template v-for="item in page_downloads">
              <template v-if="item.select_option === 2">
                <div class="flex flex-col">
                  <a :href="pdfURL + item.download" class="text-darkRed hover:text-darkBlue underline underline-offset-1"
                     href=""><span>{{ item.download_name }}</span></a>
                </div>
              </template>
            </template>
            <h2 v-if="page_downloads.length > 0 && page_downloads.filter(item=> item.select_option === 3).length > 0" class="mt-7 text-lg">MORGAN</h2>
            <template v-for="item in page_downloads">
              <template v-if="item.select_option === 3">
                <div class="flex flex-col">
                  <a :href="pdfURL + item.download" class="text-darkRed hover:text-darkBlue underline underline-offset-1"
                     href=""><span>{{ item.download_name }}</span></a>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <LoadersSpinner/>
    </div>
  </div>
</template>
<script setup>
import {computed, ref} from 'vue';
import {http} from "~/utils/http";
import {useSiteTitle, useSiteURL} from "~/composables/state";
import {Page, PageDownload} from "~/composables/nhTypes";
import { useMainStore} from '~/stores/main'
const siteTitle = useSiteTitle();
const arabian = ref(siteTitle.value.includes('Arabian'));
const siteURL = useSiteURL();
const pdfURL = ref('');
const page_downloads = ref(new PageDownload);
const page = ref(new Page);
const ready = ref(false);
const readyTable = ref(false);
const isLoggedIn = ref(true);

const breeds = ref([]);
const items = ref([]);
const selectedBreed = ref(null);
const year = ref(new Date().getFullYear())
const years = ref([]);
const mainStore = useMainStore()
const userName = computed(() => mainStore.userName)

const getPages = async () => {
  try {
    await http
        .get("/api/pages/" + 5)
        .then((response) => {
          page.value = response.data.page;
          pdfURL.value = siteURL.value + '/storage/downloads/results/' + page.value.path + '/';
        });
  } catch (e) {
    console.log(e.response.data.error);
    if(e.response?.status === 403 || e.response?.status === 401){
      isLoggedIn.value = false;
    }
    ready.value = true;
  }
  await getDownloads();
  ready.value = true;
};

const getDownloads = async () => {
  try {
    await http
        .get("/api/pages-download/" + page.value.id)
        .then((response) => {
          page_downloads.value = response.data.files;
        });
  } catch (e) {
    console.log(e.response.data.error);
  }
};

const getData = async (id=null) => {
  readyTable.value = false;
  items.value = [];
  if(id){
    selectedBreed.value = id;
  }
  try {
    await http
        .get("/api/results/point", {
          params: {
            type: 'ss',
            year: year.value,
            breed_id: selectedBreed.value
          }
        })
        .then((response) => {
          items.value =  response.data.scores;
        });
  } catch (e) {
    console.log(e);
  }
  readyTable.value = true;
}

const getPageInfo = async () => {
  items.value = [];
  try {
    await http
        .get("/api/results/point", {
          params: {
            type: 'ss',
            year: year.value,
          }
        })
        .then((response) => {
          years.value = response.data.years;
          breeds.value = response.data.breeds;
          selectedBreed.value = breeds.value[0].id;
          ready.value = true;
          getData();
        });
  } catch (e) {
    if(e.response?.status === 403 || e.response?.status === 401){
      isLoggedIn.value = false;
    }
    ready.value = true;
  }
}

Promise.all([getPages(), getPageInfo()]);
</script>
